import React from 'react';

interface IFlexIconProps {
	className?: string;
	size?: string;
}

export const Flex = ({ className, size = '72' }: IFlexIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 72 72" fill="none" className={className}>
			<rect width="72" height="72" fill="#F4F4F2" />
			<rect
				x="11.25"
				y="11.25"
				width="49.5"
				height="49.5"
				rx="7.25"
				fill="white"
				stroke="#707070"
				strokeWidth="1.5"
			/>
			<rect x="14.25" y="14.25" width="43.5" height="43.5" rx="3" fill="#F4F4F4" />
			<path d="M25.6013 39.75L36 35.25L46.3986 39.75V47.0583H36H25.6013V39.75Z" fill="#008035" />
			<path d="M25.6013 36L36 31.5L46.3986 36V38.25L36 33.75L25.6013 38.25V36Z" fill="#008035" />
			<rect x="23.25" y="22.5" width="25.5" height="27" rx="2.5" stroke="#008035" strokeWidth="3" />
			<path
				d="M28.6062 45V40.2193H31.5375V41.0865H29.6575V42.1991H31.3303V42.9972H29.6575V45H28.6062ZM32.443 45V40.2193H33.4943V44.1559H35.2439V45H32.443ZM36.115 45V40.2193H39.0309V41.0865H37.1662V42.1147H38.7547V42.9128H37.1662V44.1329H39.0309V45H36.115ZM39.4896 45L41.0473 42.4907L39.574 40.2193H40.8094L41.7456 41.7848L42.6204 40.2193H43.7791L42.3288 42.4831L43.9633 45H42.7278L41.6305 43.2197L40.5946 45H39.4896Z"
				fill="white"
			/>
			<path d="M3 60.75H64.5" stroke="#707070" strokeWidth="1.5" />
			<path d="M66.75 60.75L69 60.75" stroke="#707070" strokeWidth="1.5" />
		</svg>
	);
};
